import { render, staticRenderFns } from "./ItemDataTable.vue?vue&type=template&id=7100e9f2&"
import script from "./ItemDataTable.vue?vue&type=script&lang=js&"
export * from "./ItemDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/plugin-ceres/plugin-ceres/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7100e9f2')) {
      api.createRecord('7100e9f2', component.options)
    } else {
      api.reload('7100e9f2', component.options)
    }
    module.hot.accept("./ItemDataTable.vue?vue&type=template&id=7100e9f2&", function () {
      api.rerender('7100e9f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/ItemDataTable.vue"
export default component.exports